export const createProduct = `
    mutation createProduct($input: CreateProductInput!) {
        createProduct(input:$input) {
            id
            name
            shortDescription
            longDescription
            productImage
            status
            billingProviderId
            billingProviderRecordId
            freeTrial
            createdByUsername
            created
            updated
    }
}`;

export const updateProduct = `
    mutation updateProduct($input: UpdateProductInput!) {
        updateProduct(input:$input){
            id
            name
            shortDescription
            longDescription
            productImage
            status
            billingProviderId
            billingProviderRecordId
            freeTrial
            updated
        }
}`;

export const cloneProduct = `
    mutation cloneProduct($id: ID!) {
        cloneProduct(id:$id){
            id
            name
            shortDescription
            longDescription
            productImage
            status
            featureIds
            billingProviderId
            billingProviderRecordId
            createdByUsername
            created
            updated
        }
}`;

export const deleteProduct = `
    mutation deleteProduct($input: DeleteProductInput!) {
        deleteProduct(input:$input) 
}`;
